import React from 'react';
import PropTypes from 'prop-types';

const Contact = ({
  salestel,
  salescontact,
  agent,
  agenttel,
  agentemail,
  agent2,
  agenttel2,
  agentemail2,
  name,
  property,
}) => {
  const contact = [
    {
      name: 'Aquinna Homes',
      phone: salestel || '01494 739400',
      email: salescontact || 'sales@aquinnahomes.com',
    },
  ];
  if (agent) {
    contact.push({
      name: `${agent} - Selling Agent`,
      phone: agenttel,
      email: agentemail,
    });
  }
  if (agent2) {
    contact.push({
      name: `${agent2} - Selling Agent`,
      phone: agenttel2,
      email: agentemail2,
    });
  }

  return (
    <section className="contact">
      <div className="container">
        <h2>Contact</h2>
        <div className="row">
          {contact.map((item, i) => (
            <div className={`col-md-${12 / contact.length}`} key={i}>
              <h3>{item.name}</h3>
              <table className="table table-icon">
                <tbody>
                  {!!item.phone && (
                    <tr>
                      <td>
                        <span className="icon-2x icon-phone" aria-hidden="true" />
                      </td>
                      <td>{item.phone}</td>
                    </tr>
                  )}
                  {!!item.email && (
                    <tr>
                      <td>
                        <span className="icon-2x icon-envelope" aria-hidden="true" />
                      </td>
                      <td>
                        <a
                          href={`mailto:${item.email}?subject=${name}${
                            property ? ` ${property}` : ''
                          } - Aquinna Homes Enquiry`}
                        >
                          {item.email}
                        </a>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

Contact.propTypes = {
  salestel: PropTypes.string,
  salescontact: PropTypes.string,
  agent: PropTypes.string,
  agenttel: PropTypes.string,
  agentemail: PropTypes.string,
  agent2: PropTypes.string,
  agenttel2: PropTypes.string,
  agentemail2: PropTypes.string,
  name: PropTypes.string.isRequired,
  property: PropTypes.string,
};

export default Contact;
